import { useEffect } from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  useEffect(() => {
    document.title = "Payment Cancelled — TheKhoj";
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4" data-testid="payment-cancel-page">
      <div className="w-full max-w-md bg-card border border-border rounded-3xl p-10 text-center shadow-xl">
        <XCircle className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
        <h1 className="font-display text-2xl font-bold">Payment cancelled</h1>
        <p className="text-sm text-muted-foreground mt-3 leading-relaxed">
          No charge was made. Whenever you're ready, we're here — you can also ping us on WhatsApp
          +91 9035083242 with any questions first.
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center justify-center px-6 py-3 rounded-full bg-primary text-primary-foreground font-semibold text-sm"
          data-testid="payment-cancel-back-home"
        >
          ← Back to home
        </Link>
      </div>
    </div>
  );
}
